<template>
  <div class="wrapper">
    <vSiderBar></vSiderBar>
    <div class="main">
      <vHeader></vHeader>
      <div class="content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import vHeader from '@/components/Header/index.vue';
import vSiderBar from '@/components/Sidebar/index.vue';
import { defineComponent, ref } from 'vue';
export default defineComponent({
  components: {
    vHeader,
    vSiderBar,
  },
  setup() {
    const collapse = ref(false);
    return { collapse };
  },
});
</script>

<style scoped>
.main {
  margin-left: 191px;
}
</style>
